import * as React from "react";
import "./style.scss";
import { observer } from "mobx-react";

// Mobx
import HotelStore from "../../../../../../stores/HotelStore";

// Components
import Button from "../../../../../../components/Button";
import { default as MIconButton} from "@material-ui/core/IconButton";

// MARK: Icons
import { default as MDeleteIcon} from "@material-ui/icons/Delete";
import { default as Chip } from "@material-ui/core/Chip";

// Resources
import strings from "../../../../../../resources/strings";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class MetaTagsList extends React.Component<IProps> {
	public render() {
		const { hotelStore } = this.props;
		return(
			<div className="metags">
				<div className="metagsList">
					{this.props.hotelStore.metaTags.map((metaTag, index) => (
						<Chip
							key={`${metaTag}-${index}`}
							label={metaTag}
							onDelete={() => hotelStore.removeMetaTag(metaTag)}
							className="metaTagChip"
						/>
					))}
				</div>
				<div className="metatagsBtnContainer">
					<Button
						onClick={hotelStore.openMetaTagDialog}
						variant="contained"
					>
						{strings.hotel.edit.metaTagDialog.title}
					</Button>
				</div>
			</div>
		);
	}
}
